import { TableDataType } from "./types";

export const initialTableDataTypeState: TableDataType = {
  memberSelections: [],
  imageAttachLoading: {
    isLoading: false,
    index: "",
    name: "",
    customKey: "",
  },
  imageAttachError: {
    isError: false,
    message: "",
    name: "",
  },
  fileAttachLoading: {
    isLoading: false,
    index: "",
    name: "",
    customKey: "",
  },
  fileAttachError: {
    isError: false,
    message: "",
    name: "",
  },
};
